import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'form-domain-scan-login-types-form',
    templateUrl: './form-domain-scan-login-form.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false,
})
export class FormDomainScanLoginFormComponent implements OnInit {
    @Input() login: any = {
        form: {
            fields: [],
        },
    };

    loginShowValue: any;

    ngOnInit () {
        this.login = this.login || {};
        this.loginShowValue = {};
        if (this.login.form === null || typeof this.login.form !== 'object') {
            this.login.form = {};
        }

        if (!Array.isArray(this.login.form.fields)) {
            this.login.form.fields = [{}];
        }
        if (!this.login.verify) {
            this.login.verify = { location: '' };
        }
    }

    toggleValueVisibility (index) {
        this.loginShowValue[index] = !this.loginShowValue[index];
    }

    addFormField () {
        this.login.form.fields.push({});
    }

    removeFormField (index) {
        this.login.form.fields.splice(index, 1);
    }
}
